import CertificateModal from './certificate-modal-view';

export default CertificateModal;
